// extracted by mini-css-extract-plugin
export var post = "SecondaryPost-module--post--uKB0n";
export var postCategory = "SecondaryPost-module--postCategory--7269-";
export var postSummary = "SecondaryPost-module--postSummary--D6cVQ";